import React, { ChangeEvent, useState, useEffect, useCallback } from "react";

import { Dropdown, Image } from "react-bootstrap";
import { useSelector } from "react-redux";

import Loading from "../../../../components/loading";
import { fetchCustomFields } from "../../../../redux/actions/customFields";

import Select, { components } from "react-select";
import { useDispatch } from "react-redux";

import RichTextEditor from "../../../../components/richTextEditor";
import Button from "src/components/button";
import { updateAsset, updateCleverstoryAssetMetadata } from "src/redux/actions/assets";
import { fetchContentScore } from "src/redux/actions/contentMap";
import { CLEVERSTORY_VIEWER, HTML_VIEWER, VIDEO_VIEWER } from "src/constants/assets";
import { getSectionType, ScoreCard } from 'src/pages/contentMap/contentScore/contentScore.helper';

import moment from "moment";
import dateformat from "dateformat";
import { toast } from "react-toastify";
import Toast from "../../../../components/toast/index";

import _ from "lodash";
import cx from "classnames";
import "react-datepicker/dist/react-datepicker.css";
import styles from "./edit.module.scss";
import { Asset } from "src/types/assets";
import { useTransition, animated, useSpring, useSpringRef, useChain } from "@react-spring/web";
import VideoCaption from "../videoCaption";
import DatePickerComponent from "src/components/datePicker";
import { fixHTTPUrl, isUrlValid } from "src/utils/util";
import { FileUpload, FileUploadStatus } from "./components/fileUpload";
import { IUseFetchProps, useFetch } from "src/components/hooks/useFetch";
import { useAssetAdoption } from "src/redux/actions/adoption/asset";
import { ASSET_DETAIL, CONTENT_MAP } from "src/constants/adoption/sourceTypes";
import EventService from "src/utils/event.service";
import { useLocation } from "react-router-dom";
import { invalidateFetchingChildrenForGroup } from "src/redux/actions/groups";

import TinyMCE from 'react-tinymce/lib/components/TinyMCE';
import userRoleService from "src/utils/userRoles.service";
import AssetService from "src/utils/asset.service";

const AssetDefaultIcon = '/images/defaultIcons/default_asset.jpg';

const EXPIRY_OPTIONS = [{
  label: 'one_month',
  value: '1 Month'
},
{
  label: 'three_months',
  value: '3 Months'
},
{
  label: 'six_months',
  value: '6 Months'
},
{
  label: 'twelve_months',
  value: '12 Months'
},
{
  label: "none",
  value: "none"
}];
interface EditAssetProps {
  toggleEditAsset: () => void;
  asset: Asset,
  toggleEditVideoCaptions?: () => void;
  toggleEditThumbnail: () => void;
  showEditVideoCaptions?: boolean;
  hideCloseButton?: boolean;
  hideEditVideoCaptions?: boolean;
  selectedCard?: ScoreCard | null;
  handleEditContentsClick?: () => void;
  handleDeleteTableOfContents?: () => void;
}

const viewerOptions = [
  {
    label: "Render in Viewer",
    value: 'render_in_viewer'
  },
  {
    label: "Open in New Tab",
    value: 'open_in_new_tab'
  },
]

const EditAsset = ({ asset, toggleEditAsset, toggleEditVideoCaptions, toggleEditThumbnail, selectedCard, showEditVideoCaptions, hideEditVideoCaptions = false, handleEditContentsClick, handleDeleteTableOfContents }: EditAssetProps) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const source = new URLSearchParams(location.search).get("source");
  const sourceType = source?.split("/")[0];
  const sourceId = source?.split("/")[1];

  const errorMessage = useSelector((state: any) => _.get(state, "asset.uploadVersion.error.errors[0].message", null));
  const account = useSelector((state: any) => _.get(state, "accounts.item", null));
  const analytics = useSelector((state: any) => _.get(state, "asset.analytics.item", null));
  const primaryTextColor = _.get(account, 'theme.primaryPalette.textColor', "#000000");
  const tableOfContent = useSelector((state) => _.get(state, `asset.tableOfContents`,[]));
  const sections = _.get(tableOfContent, "sections", []);
  const loading = useSelector((state: any) =>
    _.get(state, "asset.loading", true),
  );
  const customFields = useSelector((state: any) =>
    _.get(state, "customFields.items", []),
  );
  const updating = useSelector((state: any) => _.get(state, `asset.update.${asset.id}.updating`, false));
  const updated = useSelector((state: any) => _.get(state, `asset.update.${asset.id}.updated`, false));
  const isStorageLimitReached = useSelector((state:any) => state.asset.storageLimit.isLimitReached)
  const uploadingNewVersion = useSelector((state: any) => {
    const currentAsset = _.get(state, `asset.uploadVersion.id`, null);
    return currentAsset === asset.id;
  });

  const isExpired =  _.get(asset, `expiry`, false);

  const getTagsData = () => {
    let items: { item: any; highlight: boolean }[] = [];
    if (_.get(asset, "tags")) {
      asset.tags.forEach((tag: any) => {
        items = [...items, { item: tag, highlight: false }];
      });

      return items;
    }
    return [];
  };

  const [name, setName] = useState(asset.name);
  const [icon, setIcon] = useState(asset.icon);
  const [refresClverstoryAsset, setRefreshCleverstoryAsset] = useState(false);
  const [url, setUrl] = useState(_.get(asset, "metadata.url", ""));
  const [isUrl, setIsUrl] = useState(asset.metadata.content_type === "application/url");
  const [fields, setFields] = useState(asset.customFields);
  const [internalSummary, setInternalSummary] = useState(
    _.get(asset, "summary", "") || "",
  );
  const [externalSummary, setExternalSummary] = useState(
    _.get(asset,"externalSummary","")
  );
  const [tagsInput, setTagsInput] = useState("");
  const [tags, setTags] = useState(getTagsData());
  const [recommendedTags, setRecommendedTags] = useState<any[]>([]);
  const [errors, setErrors] = useState<any>({});
  const [filterType, setFilterType] = useState("INTERNAL");
  const [expiryDate, setExpiryDate] = useState<string>();
  const [selectedExpiryDateOption, setSelectedExpiryDateOption] = useState<string>();
  const [share, setShare] = useState(_.get(asset, "settings.share", true));
  const [download, setDownload] = useState(
    _.get(asset, "settings.download", true),
  );

  const [showExpiryOptions, setShowExpiryOptions] = useState(false);
  const [options, setOptions] = useState(viewerOptions);
  const [selectedValue, setSelectedValue] = useState<string>();
  const thumbnail = _.get(asset, "icon.thumbnail", AssetDefaultIcon);
  const internalEditor = React.useRef<any>(null);
  const updatedAsset = useSelector((state: any) => _.get(state, `asset.update.${asset.id}.item`, null));

  const updateAssetProps: IUseFetchProps = {
    action: updateAsset,
    loading: updating,
    succeeded: updated,
    response: updatedAsset,
    error: null
  };

  const { handleFetch: updateAssetRequest } = useFetch(updateAssetProps);

  const { trackAssetEdited } = useAssetAdoption();

  const getViewerMode = () => {
    if (_.get(asset, "viewer.type", "") === CLEVERSTORY_VIEWER) {
      setSelectedValue(_.get(asset,"viewer.mode"));
    } else {
      const optimizedViewer = {
        label: "Render Optimized View",
        value: 'render_optimized_view'
    }
    if(!_.find(viewerOptions,optimizedViewer)){
      viewerOptions.push(optimizedViewer)
     }
      setSelectedValue(_.get(asset, "viewer.mode"))
    }
  }

  const captionRef = useSpringRef()
  const transitions = useTransition(showEditVideoCaptions, {
    ref: captionRef,
    from: { transform: 'translateY(100%)', opacity: 0 },
    enter: { transform: 'translateY(0) ', opacity: 1 },
    leave: { transform: 'translateY(100%)', opacity: 0 },
    config: {
      tension: 220, friction: 50,
      easeInBounce: 0.5
    },
  });
  const editRef = useSpringRef()
  const springStyles = useSpring({
    ref: editRef,
    opacity: showEditVideoCaptions ? 0 : 1,
    pointerEvents: showEditVideoCaptions ? 'none' : 'auto',
  });
  useChain([editRef, captionRef], showEditVideoCaptions ? [0, 0.3] : [0.3, 0])

  const handleChange = (e: ChangeEvent<HTMLInputElement>, type: string) => {
    setName(e.target.value);
  };

  const handleCustomFieldClick = (fields: any) => {
    setFields(fields);
  }

  const hanldeTagsInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setTagsInput(e.target.value);
  };

  const handleTagsKeyDown = (e: any) => {
    if (_.size(tags) == 0 && tagsInput.length == 0) {
      return;
    }
    if (e.keyCode === 13 || e.keyCode == 9) {
      //Enter
      if (tagsInput.length > 0) {
        if (tags.find((tag: any) => tag.item === tagsInput)) {
          setTagsInput("");
          return;
        }
        setTags([...tags, { item: tagsInput, highlight: false }]);
        setTagsInput("");
      }
    }

    if (e.keyCode === 8 && tagsInput.length === 0) {
      //Backspace
      var items = tags;
      var highlight = tagsInput.length === 0;
      var lastItem = items[items.length - 1];
      if (!highlight) {
        lastItem.highlight = highlight;
      } else if (lastItem && lastItem.highlight) {
        //delete
        items = items.slice(0, items.length - 1);
      } else {
        lastItem.highlight = highlight;
      }
      setTags(items);
    }
  };

  const handleTagClose = (tag: any) => {
    const filteredTags = tags.filter((item: any) => {
      return item !== tag;
    });

    setTags(filteredTags);
  };

  const handleRecommendedTagClick = (tag: string) => {
    setTags([...tags, { item: tag, highlight: false }]);
  };

  const handleEditorChange = (e: any) => {
    const content = e.target.getContent();
    if (filterType === "INTERNAL") {
      setInternalSummary(content);
    } else if (filterType === "EXTERNAL") {
      setExternalSummary(content);
    }
  };

  const validateUpdateRequest = () => {
    let errors = {};

    if (!url || url.trim().length === 0) {
      errors = {
        ...errors,
        url: "Please provide a valid URL",
      };
    }

    if (isUrl && url && _.get(asset, "metadata.url", "") !== url) {
      const fixedUrl = fixHTTPUrl(url)
      setUrl(fixedUrl)

      if (!isUrlValid(fixedUrl)) {
        errors = {
          ...errors,
          url: "Please provide a valid URL",
        };
      }
    }
    if (!name || name.trim().length === 0) {
      errors = {
        ...errors,
        name: "Please provide a valid name",
      };
    }

    return errors;
  }

  const getExpiryDate = (date: string) => {
    const parsedDate = new Date(date);
    const formattedDate = moment(parsedDate).format('YYYY-MM-DD');
    return formattedDate;
  }

  const handleEditAsset = () => {
    setRefreshCleverstoryAsset(false)
    const settings = {
      share: share,
      download: download
    }

    const filteredTags = tags.map((tag: any) => {
      return tag.item;
    });

    if (isUrl && url && url !== _.get(asset, "metadata.url", "")) {
      const fixedUrl = fixHTTPUrl(url)
      setUrl(fixedUrl)
    }

    let updateRequest: any = {
      id: asset.id,
      name: name,
      icon: icon?.id,
      summary: internalSummary,
      externalSummary: externalSummary,
      tags: filteredTags,
      customFields: fields,
      settings: settings,
      expiryDate: expiryDate ? getExpiryDate(expiryDate) : null,
      resetExpiryDate: selectedExpiryDateOption == "none",
    }
    if (isUrl) {
      updateRequest = {
        ...updateRequest,
        url: url,
        viewerMode: selectedValue,
      }
    }

    if(_.get(asset, "viewer.type") === CLEVERSTORY_VIEWER) {
      updateRequest = {
        ...updateRequest,
        cleverstoryViewerMode: selectedValue
      }
    }
    const errors = validateUpdateRequest();

    setErrors(errors);

    if (_.size(errors) === 0) {
      if (sourceType === "groups" && sourceId) {
        dispatch(invalidateFetchingChildrenForGroup({ id: sourceId }));
      }

      updateAssetRequest({
        id: asset.id,
        request: updateRequest
      }).then((response) => {

        let sourceCta = CONTENT_MAP;
        if(location.pathname.includes("assets")) {
          sourceCta = ASSET_DETAIL;
        }
        trackAssetEdited({
          sourceCta: sourceCta,
          response: response,
          ...(selectedCard && { sectionType: getSectionType(selectedCard.key) })
        });
      });
    }
  }

  const checkIfMarkedInternal = () => {
    const previous = _.get(asset, 'settings.share');
    const current = share;

    return previous != current && !current;
  }

  const restrictUpdate = () => {

    // expired assets settings should not be updated if expireContent is true
    const expireContent = _.get(account, 'contentSettings.expireContent', false);

    if (expireContent && isExpired && (share !== _.get(asset, 'settings.share') || download !== _.get(asset, 'settings.download'))) {
      return true;
    }

    return false;
    
  }

  const handleSave = () => {
    if (!share && checkIfMarkedInternal()) {
      const warningMessage = (
        <div>
          <span>This asset has <b>{analytics.views || 0}</b> views and <b>{analytics.shares || 0}</b> shares.</span>
          <p>If you do, you can only share this asset with Paperflite users within your team. Anyone else you&rsquo;ve shared this with will lose access.
          Want to continue?</p>
          <button
            className={styles.warningMessage}
            onClick={() => {
              toast.dismiss();
              handleEditAsset()
            }}
          >
            <i className="paperflite-tick" />
            <p className={styles.toastConfirm}>Yes</p>
          </button>
        </div>
      );
      toast(<Toast.warning className={styles.warningToast} heading={'Mark as "internal"'} message={warningMessage} />, {
        autoClose: false
      });
      return
    }

    if (restrictUpdate()) {
      const warningMessage = (
        <div>
          <p>This asset has expired. Extend the expiry date to enable sharing or downloading.</p>
        </div>
      );
      toast(<Toast.warning className={styles.warningToast} heading={'Expired Asset Warning'} message={warningMessage} />, {
        autoClose: false
      });
      return
    }

    if (updating) {
      return;
    }

    handleEditAsset();
  }

  const handleUrlChange = (e: ChangeEvent<HTMLInputElement>) => {
    setUrl(e.target.value);
  }

  const getStyles = () => {
    return {
      control: (base: any, state: any) => ({
        ...base,
        padding: "0.25rem 0",
        background: "none",
        borderRadius: "0.625rem",
        outLine: "none",
        boxShadow: state.isFocused ? 0 : base.boxShadow,
        border: state.isFocused ? "1px solid #dbdbdb" : base.border,
        "&:hover": {
          boxShadow: state.isFocused ? 0 : base.boxShadow,
        },
      }),

      menu: (base: any) => ({
        ...base,
        padding: "1rem",
        borderRadius: "0.625rem",
      }),

      singleValue: (base: any) => ({
        ...base,
        width: "fit-content",
        padding: "0.375rem 0.5rem",
        fontFamily: "Gilroy, sans-serif",
        fontSize: "0.75rem",
        fontStyle: "normal",
        fontWeight: "500",
        ":hover": {
          color: "#000",
          background: "none",
        },
      }),
      indicatorsContainer: (base: any) => ({
        ...base,
      }),
      indicatorSeparator: (base: any) => ({
        ...base,
        alignSelf: "auto",
      }),
      dropdownIndicator: (base: any, state: any) => ({
        ...base,
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
        color: "#717274",
        "&:hover": {
          color: "#717274",
        },
        svg: {
          height: "16px",
          width: "16px",
        },
      }),
    };
  };

  const getExpiryDateForFilter = (value: string) => {
    const currentDate = moment();
    switch (value) {
      case "one_month":
        return currentDate.add(1, "months");
      case "three_months":
        return currentDate.add(3, "months");
      case "six_months":
        return currentDate.add(6, "months");
      case "twelve_months":
        return currentDate.add(12, "months");
    }
  };

  const handleRefresh = () => {
    setRefreshCleverstoryAsset(true)
    if (updating) {
      return;
    }
    dispatch(updateCleverstoryAssetMetadata({ id: asset.id }));
  }

  const handleReset = (value: string) => {
    setExpiryDate("");
    setSelectedExpiryDateOption(value);
  }

  const handleExpiryOption = (value: string) => {
    if (value == "none") {
      handleReset(value)
    }
    else {
      const expiryDate = getExpiryDateForFilter(value);
      const selectedDate = moment(expiryDate).format('DD MMM YYYY');
      setExpiryDate(selectedDate);
      setSelectedExpiryDateOption(value);
    }
  }

  const handleChangeExpiryDate = (date: Date | null) => {
    const selectedDate = moment(date).format('DD MMM YYYY');
    setExpiryDate(selectedDate);
    setShowExpiryOptions(false);
    setSelectedExpiryDateOption("");
  }

  const handleEditVideoCaptions = () => {
    toggleEditVideoCaptions && toggleEditVideoCaptions();
  }

  const handleEditThumbnail = () => {
    toggleEditAsset();
    toggleEditThumbnail();
  }
  useEffect(() => {
    dispatch(fetchCustomFields(true));
    getViewerMode();

    const expiryValue = AssetService.getNumericValue(asset, "expiryDate");

    if (expiryValue && expiryValue !== 0) {
      const expiryDate = new Date(expiryValue);
      const formattedExpiryDate = `${expiryDate.getUTCDate()} ${expiryDate.toLocaleString('en-US', {
        month: 'short',
      })} ${expiryDate.getUTCFullYear()}`;

      setExpiryDate(formattedExpiryDate);
    }
  }, []);

  useEffect(() => {
    let items: { item: any; highlight: boolean }[] = [];

    if (_.get(asset, "recommendedTags")) {
      asset.recommendedTags.forEach((recommendedTag: any) => {
        if (!tags.find((tag: any) => tag.item === recommendedTag)) {
          items = [...items, recommendedTag];
        }
      });
      setRecommendedTags(items);
    }
  }, [tags]);

  useEffect(() => {
    setName(asset.name);
    setIcon(asset.icon);
    setUrl(asset.metadata.url || '');
    setInternalSummary(asset.summary || '');
    setExternalSummary(asset.externalSummary || '');
    setTags(getTagsData());
    setIsUrl(_.get(asset, "metadata.content_type") === "application/url");
    setFields(asset.customFields);
    setShare(_.get(asset, "settings.share", true));
    setDownload(_.get(asset, "settings.download", true));
    if (updated && !refresClverstoryAsset) {
      toggleEditAsset()
    }
    
  if(internalEditor?.current?.setContent && updated) {
      internalEditor.current.setContent(asset.summary || "");
  }
   
  dispatch(fetchContentScore());
    
  }, [updated]);

  useEffect(() => {
    if (_.get(asset, "icon")){
      setIcon(_.get(asset, "icon"))
    }
  },[_.get(asset, "icon")])

    useEffect(() => {
    if (isStorageLimitReached) {
      toast(<Toast.warning heading="Warning" message={errorMessage} />, {
        position: "bottom-right",
        autoClose: false,
        className: styles.toastAlert
      });
    }
  }, [isStorageLimitReached])

  if (loading) {
    return <Loading />;
  }

  const baseStyles = getStyles();
  const customStyles = {
    ...baseStyles,
    singleValue: (provided: any) => {
      const original = baseStyles.singleValue(provided);
      return {
        ...original,
        "&:hover": { 
          background: "none",  
        },
      };
    },
  };

  return (
    <section className={cx(styles.container)}>
      <animated.div style={{ ...springStyles, pointerEvents: springStyles.pointerEvents as any }} className={styles.editAsset}>
        <div className={styles.verticalLine}></div>
        <div className={styles.header}>
          <h3>edit asset</h3>
          <div className={styles.actions}>
            {!_.get(asset, "datasource") && !isUrl && (!(uploadingNewVersion && !isStorageLimitReached)) && <FileUpload asset={asset} />}
          </div>
        </div>
        <div className={styles.thumbnailContainer}>
          <div className={styles.assetIconContainer}>
            <Image className={styles.assetIcon} src={thumbnail} />
            <div
              onClick={() => handleEditThumbnail()}
              className={styles.uploadIconLayer}
            >
              <i className={cx("paperflite-edit", styles.editIcon)}></i>
            </div>
          </div>
          {!uploadingNewVersion && !isUrl &&
            _.get(asset, "viewer.type") === CLEVERSTORY_VIEWER && (
              <span
                onClick={() => handleRefresh()}
                className={styles.refreshButton}
              >
                <i className="fas fa-sync" />
                <span className={styles.refresh}>Refresh</span>
              </span>
            )}

          {uploadingNewVersion  && !isStorageLimitReached && (
            <FileUploadStatus asset={asset} />
          )}
        </div>
        <section className={styles.assetEditFieldsContainer}>
          {isUrl && (
            <div className={styles.assetNameCol}>
              <label className={styles.fieldName}>Link</label>
              <input
                className={styles.input}
                type="url"
                placeholder="eg: https://app.paperflite.com/collections"
                onChange={handleUrlChange}
                disabled={_.get(asset,"datasource.type") != null}
                value={url}
              />
              {errors.url && (
                <span className={styles.errorMessage}>
                  <i className="paperflite-danger" aria-hidden="true"></i>
                  {errors.url}
                </span>
              )}
            </div>
          )}
          <div className={styles.assetNameCol}>
            <label className={styles.fieldName}>Name</label>
            <input
              className={styles.input}
              type="text"
              placeholder="Provide asset name"
              onChange={(e) => handleChange(e, "name")}
              value={name}
              disabled={_.get(asset,"datasource.type")!= null}
              spellCheck={true}
            />
            {errors.name && (
              <span className={styles.errorMessage}>
                <i className="paperflite-danger" aria-hidden="true"></i>
                {errors.name}
              </span>
            )}
          </div>
          {_.get(asset, "metadata.pages", 0) > 0 && <div className={styles.tableOfContent}>
            <div>
              <div className={styles.title}>Table of contents{_.size(sections) > 0 ? `(${_.size(sections)})` : ""}</div>
              {_.get(tableOfContent, "modifiedDate", false) ? <div className={styles.subText}>last edited - {dateformat(_.get(tableOfContent, "modifiedDate"), 'dd mmm yyyy')}</div> : <div className={styles.subText}> no data available  </div>}
            </div>
            <div className={styles.actions}>
              {_.size(sections) > 0 ? <>
                <i className={cx("paperflite-edit", styles.editIcon)} onClick={handleEditContentsClick && handleEditContentsClick} />
                <i className={cx("paperflite-delete", {
                  [styles.disabled]: _.size(sections) === 0
                })} onClick={handleDeleteTableOfContents && handleDeleteTableOfContents} />
              </> : <div onClick={handleEditContentsClick && handleEditContentsClick} className={styles.addContent}>
                <i className={cx("paperflite-add")} /> add
              </div>}
            </div>
          </div>}
          <div className={styles.assetDescriptionCol}>
            <div className={styles.filters}>
              <span
                onClick={() => {
                  setFilterType("INTERNAL")
                }}
                className={cx(styles.type, {
                  [styles.active]: filterType === "INTERNAL",
                })}
              >
                Internal Description
              </span>
              {userRoleService.canShare() && (
                <span
                  onClick={() => {
                    setFilterType("EXTERNAL")
                  }}
                  className={cx(styles.type, {
                    [styles.active]: filterType === "EXTERNAL",
                  })}
                >
                  External Description
                </span>
              )}
              <div
                className={cx(styles.borderline, {
                  [styles.activeInternal]: filterType === "INTERNAL",
                  [styles.activeExternal]: filterType === "EXTERNAL",
                })}
              />
            </div>
              {
                filterType === "INTERNAL" && 
                <div key={asset.id}>
                <TinyMCE
                content={internalSummary}
                config={{
                  branding: false,
                  statusbar: false,
                  contextmenu: false,
                  theme: 'silver',
                  plugins: 'code, noneditable, link, paste, autolink',
                  menubar: false,
                  toolbar1: 'undo redo | bold italic | alignleft aligncenter alignright | link',
                  resize: false,
                  height: 157,
                  paste_retain_style_properties: "color font-size",
                  content_css: [
                    'https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i'
                  ],
                  content_style: `body.mce-content-body{color: ${primaryTextColor}}`,
                  default_link_target: "_blank",
                  browser_spellcheck: true,
                  convert_urls: false,
                  relative_urls: false,
                  remove_script_host: false,
                  setup: (editor) => {
                    // having timeout to set the instance after the render of tinymce
                    editor.on('PostRender', () => {
                      setTimeout(() => {
                        internalEditor.current = editor;
                        },1000)
                  })
               },
                }}
                onChange={handleEditorChange}
              />        
              </div>
              }
              {
                filterType === "EXTERNAL" && 
                <TinyMCE
                content={externalSummary}
                config={{
                  branding: false,
                  statusbar: false,
                  contextmenu: false,
                  theme: 'silver',
                  plugins: 'code, noneditable, link, paste, autolink',
                  menubar: false,
                  toolbar1: 'undo redo | bold italic | alignleft aligncenter alignright | link',
                  resize: false,
                  height: 157,
                  paste_retain_style_properties: "color font-size",
                  content_css: [
                    'https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i'
                  ],
                  content_style: `body.mce-content-body{color: ${primaryTextColor}}`,
                  default_link_target: "_blank",
                  browser_spellcheck: true,
                  convert_urls: false,
                  relative_urls: false,
                  remove_script_host: false,
                }}
                onChange={handleEditorChange}
              />
              }
          </div>
          {!hideEditVideoCaptions && _.get(asset, "viewer.type") === VIDEO_VIEWER &&
            account.subtitleEnabled &&
            _.get(asset, "metadata.content_type") !== "application/url" && (
              <div
                className={styles.editVideoCaption}
                onClick={() => handleEditVideoCaptions()}
              >
                <i className={cx(styles.editIcon, "paperflite-edit")} />
                <span className={styles.editCaption}>Edit Video Caption</span>
              </div>
            )}
          {(_.get(asset, "viewer.type") === HTML_VIEWER || _.get(asset, "viewer.type") === CLEVERSTORY_VIEWER) && (
            <div className={styles.viewerMode}>
              <label className={styles.fieldName}>Viewer</label>
              <div className={styles.defaultValueList}>
                <Select
                  name="options_field"
                  options={options}
                  value={viewerOptions.filter(
                    (viewerOption: any) => viewerOption.value === selectedValue,
                  )}
                  onChange={(e: any) => setSelectedValue(e.value)}
                  isClearable={false}
                  isSearchable={false}
                  styles={customStyles}
                  placeholder=""
                  components={{
                    Option: ({ children, innerProps }: any) => {
                      const active = viewerOptions.find(
                        (viewerOption: any) => viewerOption.value === selectedValue,
                      )
                      return (<div className={styles.customOptions} {...innerProps}>
                        <i
                          className={cx(styles.option, {
                            [`fa fa-solid fa-circle-check ${styles.selected}`]: _.get(active, "label") === children,
                            ["fa fa-regular fa-circle"]: _.get(active, "label") !== children,
                          })}
                        />
                        <span className={styles.item}> {children} </span>
                      </div>)
                    },
                    NoOptionsMessage: ({ children, innerProps }: any) => (
                      <div {...innerProps}>
                        <span className={styles.item}>{children}</span>
                      </div>
                    ),
                  }}
                />
              </div>
            </div>
          )}
          <div className={styles.assetTagsCol}>
            <label className={styles.fieldName}>Tags</label>
            <div className={styles.tagsContainer}>
              {_.size(tags) > 0 && (
                <div className={styles.lists}>
                  {tags.map((tag: any, index: number) => {
                    return (
                      <div
                        key={`tag_${index}`}
                        className={cx(styles.list, styles.tagItem, {
                          [styles.highlight]: tag.highlight,
                        })}
                      >
                        <Tag className="" tag={tag.item} key={`tag_${index}`} />
                        <i
                          className="paperflite-close"
                          onClick={() => handleTagClose(tag)}
                        />
                      </div>
                    );
                  })}
                </div>
              )}
              <input
                className={cx(styles.inputBox, {
                  [styles.noMargins]: _.size(tags) === 0
                })}
                type="text"
                value={tagsInput}
                placeholder="Add Tags..."
                onChange={(e) => hanldeTagsInputChange(e)}
                onKeyDown={(e) => handleTagsKeyDown(e)}
              />
              {_.size(recommendedTags) > 0 && (
                <div className={cx(styles.recommendedTags)}>
                  <div className={styles.borderLine}></div>
                  <div className={styles.tagsDescription}>
                    <p>
                    Tags help to locate your file easily. Fancy any of these?
                    </p>
                  </div>
                  <div className={styles.lists}>
                    {(recommendedTags || []).map((tag: string, index: number) => {
                      return (
                        <Tag
                          className={styles.list}
                          tag={tag}
                          key={`tag_${index}`}
                          onClick={handleRecommendedTagClick}
                        />
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className={styles.assetExpiryContainer}>
            <div className={styles.expiry}>
              <label className={styles.fieldName}>Asset Expiration</label>
      
              <Dropdown
                show={showExpiryOptions}
                onToggle={() => setShowExpiryOptions(!showExpiryOptions)}
              >
                <Dropdown.Toggle className={styles.button} as={"button"}>
                  <i className="paperflite-edit" />
                </Dropdown.Toggle>
                <Dropdown.Menu
                  rootCloseEvent="click"
                  className={styles.dropdown}
                  popperConfig={{
                    modifiers: [
                      {
                        name: "offset",
                        options: {
                          offset: [0, 6],
                        },
                      },
                    ],
                  }}
                >
                  {EXPIRY_OPTIONS.map((item, index) => {
                    const active = item.label === selectedExpiryDateOption;
                    return (
                      <Dropdown.Item
                        key={index}
                        className={cx(styles.dropdownItem, {
                          [styles.active]: active,
                        })}
                        onClick={() => handleExpiryOption(item.label)}
                      >
                        <i
                          className={
                            active
                              ? "fa-solid fa-circle-check"
                              : "fa-regular fa-circle"
                          }
                        />
                        <span className={styles.option}>{item.value}</span>
                      </Dropdown.Item>
                    );
                  })}
                  <div
                    className={styles.datePicker}
                    onClick={() => setShowExpiryOptions(true)}
                  >
                    <Dropdown.Item
                      className={cx(styles.dropdownItem, {
                        [styles.active]: true,
                      })}
                    >
                      <DatePickerComponent
                        value={expiryDate}
                        handleDateChange={handleChangeExpiryDate}
                      />
                    </Dropdown.Item>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div
              className={styles.assetNameCol}
              onClick={() => setShowExpiryOptions(true)}
            >
              <input
                className={styles.expiryInput}
                type="text"
                readOnly
                value={expiryDate ? expiryDate : "Pick a Date"}
              />
            </div>
          </div>
          <section className={styles.assetAccessSection}>
            <label className={styles.fieldName}>Asset Access</label>
            <div className={styles.assetAccess}>
              {userRoleService.canShare() && (
                <div className={styles.share} onClick={() => setShare(!share)}>
                  <i
                    className={cx(
                      styles.icon,
                      { [styles.selected]: share },
                      share ? "fa-solid fa-check-circle" : "fa-regular fa-circle",
                    )}
                  />
                  <div className={styles.content}>Share</div>
                </div>
              )}
              <div
                className={styles.download}
                onClick={() => setDownload(!download)}
              >
                <i
                  className={cx(
                    styles.icon,
                    { [styles.selected]: download },
                    download
                      ? "fa-solid fa-check-circle"
                      : "fa-regular fa-circle",
                  )}
                />
                <div className={styles.content}>Download</div>
              </div>
            </div>
          </section>
          <div className={styles.customFieldsContainer}>
            {_.size(customFields) > 0 &&
              customFields.map((field: any) => {
                return (
                  <EditCustomField
                    key={field.id}
                    field={field}
                    selectedCustomFields={fields}
                    onOptionChange={handleCustomFieldClick}
                    isSearchable={true}
                  />
                );
              })}
          </div>
        </section>
        <div className={styles.footer}>
          <div className={styles.buttonContainer}>
            <Button
              variant="primary"
              className={styles.saveButton}
              icon="paperflite-tick"
              text={updating ? "Updating..." : "Update"}
              disabled={updating}
              onClick={() => handleSave()}
            />
            {!updating && (
              <Button
                variant="secondary"
                className={styles.cancelButton}
                onClick={() => {
                  setRefreshCleverstoryAsset(false)
                  toggleEditAsset()}}
                text="Cancel"
              />
            )}
          </div>
        </div>
      </animated.div>
      {transitions(
        (style, item) =>
          item && (
            <animated.div style={style} className={styles.caption}>
              <VideoCaption asset={asset} onClose={() => toggleEditVideoCaptions && toggleEditVideoCaptions()} />
            </animated.div>
          )
      )}
    </section>
  );
};

interface TagProps {
  className: string;
  tag: string;
  onClick?: (tag: string) => void;
}

const Tag = ({ className, tag, onClick }: TagProps) => {
  const handleTagClick = () => {
    if (onClick) {
      onClick(tag);
    }
  };
  return (
    <div className={className} onClick={() => handleTagClick()}>
      <span>{tag}</span>
    </div>
  );
};

interface CustomFieldProps {
  field: any;
  selectedCustomFields: any;
  onOptionChange: (fields: any) => void;
  isSearchable?: boolean;
}

interface CustomField {
  id: string | number;
  value: Option[];
}

interface Option {
  id: string | number;
  value: string;
}

export const EditCustomField = ({ field, selectedCustomFields, onOptionChange, isSearchable = false }: CustomFieldProps) => {

  const populateOptions = (
    options: Option[],
    selectedCustomFields: CustomField[],
    fieldId: string | number,
    isMultiSelect: boolean
  ): { value: Option; label: string }[] => {

    if (!isMultiSelect) {
      return options.map((option) => ({
        value: option,
        label: option.value,
      }));
    }

    let selectedValues: Option[] = [];
    if (selectedCustomFields) {
      const field = selectedCustomFields.find((field: any) => field.id === fieldId);
      selectedValues = field?.value || [];
    }
    
    return options
      .filter((option) =>
        !selectedValues.some((selected) => selected.id === option.id)
      )
      .map((option) => ({
        value: option,
        label: option.value,
      }));
  };
  
  const getDefaultValues = () => {
    if (!selectedCustomFields) {
      return null;
    }

    const selectedField = selectedCustomFields.find((item: any) => {
      return item.id === field.id;
    });

    if (!selectedField || !selectedField.value) {
      return null;
    }

    return selectedField.value.map((option: any) => {
      return {
        value: option,
        label: option.value,
      };
    });
  };

  const handleOptionChange = (customField, options) => {
    let values: any[] = [];
    if (!customField.multiselect && options) {
      values.push(options);
    } else {
      values = options;
    }

    let assetFields = selectedCustomFields || [];

    const selectedFieldIndex = assetFields && assetFields.findIndex((assetField: any) => {
      return assetField.id === customField.id;
    });

    if (selectedFieldIndex == -1) {
      const selectedField = {
        id: customField.id,
        name: customField.name,
        value: values,
      };

      assetFields = [...assetFields, selectedField];
    } else {
      let selectedField = assetFields[selectedFieldIndex];
      selectedField = {
        ...selectedField,
        value: values,
      };

      assetFields = assetFields.map((assetField: any) => {
        if (assetField.id === selectedField.id) {
          return selectedField;
        }

        return assetField;
      });
    }
    assetFields = assetFields.filter((item: any) => {
      return !_.isEmpty(item.value);
    });

    onOptionChange(assetFields);
  };

  const handleChange = (options: any) => {
    if (field.multiselect) {
      const values = options.map((item: any) => {
        if (item.label) {
          return item.value;
        }
        return item;
      });
      handleOptionChange(field, values);
    } else {
      handleOptionChange(field, options ? options.value : null);
    }
  };

  const getStyles = () => {
    return {
      control: (base: any, state: any) => ({
        ...base,
        background: "#FAFAFA",
        border: "1px solid #dbdbdb",
        borderRadius: "0.625rem",
        boxShadow: state.isFocused ? 0 : base.boxShadow,
        "&:hover": {
          border: state.isFocused ? "1px solid #dbdbdb" : base.border,
          boxShadow: state.isFocused ? 0 : base.boxShadow,
        },
      }),

      menu: (base: any) => ({
        ...base,
        padding: "1rem",
        borderRadius: "0.75rem",
        background: "#FAFAFA",
        boxShadow: "0px 0px 16px 0px rgba(18, 18, 18, 0.08)",
        backdropFilter: "blur(2px)",
      }),

      singleValue: (base: any) => ({
        ...base,
        width: "fit-content",
        padding: "0.375rem 0.5rem",
        fontFamilt: "Gilroy Regular",
        fontSize: "0.75rem",
        fontStyle: "normal",
        fontWweight: "400",
        background: "#e5e5e5",
        borderRadius: "1.25rem",
        "&:hover": {
          color: "#fff",
          background: "#A9A9A9",
        },
      }),
      multiValue: (base: any) => ({
        ...base,
        padding: "0.375rem 0.5rem",
        fontFamilt: "Gilroy Regular",
        fontSize: "0.75rem",
        fontStyle: "normal",
        fontWweight: "400",
        background: "#e5e5e5",
        borderRadius: "1.25rem",
        marginRight: "4px",
        "&:hover": {
          color: "#fff",
          background: "#A9A9A9",
          "*": {
            color: "#fff",
          }
        },
      }),
   
      singleValueRemove: (base: any) => ({
        ...base,
        color: "#000",
        padding: "0px",
        fontSize: "1em",
        lineHeight: "1em",
        "&:hover": {
          color: "#fff",
          background: "#A9A9A9",
        },
      }),
      multiValueRemove: (base: any) => ({
        ...base,
        color: "#000",
        padding: "0px",
        fontSize: "1em",
        lineHeight: "1em",
        "&:hover": {
          color: "#fff",
          background: "none",
        },
      }),
      indicatorsContainer: (base: any) => ({
        ...base,
        display: "none",
      }),
      indicatorSeparator: (base: any) => ({
        ...base,
        alignSelf: "auto",
      }),
      dropdownIndicator: (base: any, state: any) => ({
        ...base,
        transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
        color: " var(--primarySubTextColor)",
        "&:hover": {
          color: " var(--primarySubTextColor)",
        },
        svg: {
          height: "16px",
          width: "16px",
        },
      }),
    };
  };

  const options = populateOptions(field.options, selectedCustomFields, field.id, field.multiselect);

  return (
    <div className={styles.customFieldContent}>
      <label className={styles.fieldName}>{field.name}</label>
      <div className={styles.defaultValueList}>
        <Select
          id={`${field.id}-id`}
          name={`${field.name}-field`}
          isSearchable={isSearchable}
          isMulti={field.multiselect}
          onChange={(e) => handleChange(e)}
          defaultValue={getDefaultValues()}
          closeMenuOnSelect={false}
          options={options}
          styles={getStyles()}
          components={{
            Option: ({ children, innerRef, innerProps, data }: any) => {
              const isSelected = _.some(selectedCustomFields, (selectedField: any) => {
                if (selectedField.id === field.id) {
                  return selectedField.value.some((item: any) => item.id === data.value.id);
                }
                return false;
              });             
              return (
                <div
                  ref={innerRef}
                  className={cx(styles.customOptions, {
                    [styles.active]: isSelected,
                    [styles.disabled]: isSelected,
                  })}
                  {...innerProps}
                >
                  <i className={cx(styles.option, isSelected ? "paperflite-radio-button-selected" : "paperflite-radio-button-unselected")} />
                  <span className={styles.item}> {children} </span>
                </div>
              )
            },
            NoOptionsMessage: ({ children, innerProps }: any) => (
              <div {...innerProps}>
                <span className={styles.noOptionsMessage}>{children}</span>
              </div>
            ),
            MultiValueRemove: CustomMultiValueRemove,
            SingleValue: CustomSingleValue
          }}
          placeholder=""
        />
      </div>
    </div>
  );
};

const CustomMultiValueRemove = (props) => {
  return (
    <components.MultiValueRemove {...props}>
      <i className={cx("paperflite-close", styles.closeButton)}></i>
    </components.MultiValueRemove>
  );
};

const CustomSingleValue = (props) => {
  return (
    <components.SingleValue {...props}>
      <span className={styles.item}>{props.data.label}</span>
      <i
        className={cx("paperflite-close", styles.closeIcon)}
        onClick={(e) => {
          e.stopPropagation();
          props.selectProps.onChange(null);
        }}
      ></i>
    </components.SingleValue>
  );
};

export default EditAsset;